import { audio } from "../../lib/audio";

let ctx: AudioContext | null = null;

/** A phone vibrating on a hard surface, panned to where it lies (right of the keyboard). */
export function vibrate(pan = 0.35, bursts = 2) {
  if (!audio.isEnabled()) return;
  try {
    ctx = ctx ?? new AudioContext();
  } catch {
    return;
  }
  const c = ctx;
  if (c.state === "suspended") void c.resume();
  const now = c.currentTime + 0.02;
  const out = c.createStereoPanner();
  out.pan.value = pan;
  out.connect(c.destination);
  for (let b = 0; b < bursts; b++) {
    const t = now + b * 0.62;
    const osc = c.createOscillator();
    osc.type = "sawtooth";
    osc.frequency.value = 148;
    const lp = c.createBiquadFilter();
    lp.type = "lowpass";
    lp.frequency.value = 380;
    const g = c.createGain();
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.22, t + 0.025);
    g.gain.setValueAtTime(0.22, t + 0.36);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.42);
    // the rattle of the phone body against the desk
    const lfo = c.createOscillator();
    lfo.frequency.value = 31;
    const lg = c.createGain();
    lg.gain.value = 0.09;
    lfo.connect(lg);
    lg.connect(g.gain);
    osc.connect(lp);
    lp.connect(g);
    g.connect(out);
    osc.start(t);
    osc.stop(t + 0.45);
    lfo.start(t);
    lfo.stop(t + 0.45);
  }
}

/** Makes the 3D phone (env.deskMobile) shake and light up, or stop. */
export function setDeskBuzz(on: boolean) {
  window.dispatchEvent(new CustomEvent("cf-desk-mobile", { detail: { buzz: on } }));
}
